export default __webpack_public_path__ + "static/media/brand14.e41384ba.svg";